export const chartColors = {
    actualLine: '#58508d',
    actualFill: 'rgba(88, 80, 141, 0.2)',
    targetLine: '#c92a2a',
  };